import { useEffect, useMemo, useState } from 'react';
import api from '../../services/api';
import PMModal from './PMModal';import "../../assets/styles/PM/PMOffboardingMgmtPg.css";

function PMOffboardingMgmtPg() {
  const [rows, setRows] = useState([]);
  const [active, setActive] = useState(null);
  const [comment, setComment] = useState('');
  const [meetingDate, setMeetingDate] = useState('');
  const [meetingTime, setMeetingTime] = useState('');
  const [noticeStart, setNoticeStart] = useState('');
  const [noticeEnd, setNoticeEnd] = useState('');
  const [noticeDuration, setNoticeDuration] = useState('');
  const [loading, setLoading] = useState(false);
  const [viewUrl, setViewUrl] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.getPMHrRequests();
      setRows((Array.isArray(data) ? data : []).filter((r) => String(r.request_type) === 'offboarding'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {load();}, []);

  useEffect(() => {
    if (!noticeStart || !noticeEnd) {
      setNoticeDuration('');
      return;
    }
    const s = new Date(noticeStart);
    const e = new Date(noticeEnd);
    if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime()) || e < s) {
      setNoticeDuration('');
      return;
    }
    const days = Math.floor((e - s) / (1000 * 60 * 60 * 24)) + 1;
    setNoticeDuration(String(days));
  }, [noticeStart, noticeEnd]);

  const openReq = (r) => {
    setActive(r);
    setComment(r.pm_comment || '');
    setMeetingDate(r.meeting_date || '');
    setMeetingTime(r.meeting_time || '');
    setNoticeStart(r.notice_start_date || '');
    setNoticeEnd(r.notice_end_date || '');
    setNoticeDuration(r.notice_duration || '');
  };

  const doAction = async (action) => {
    if (!active?.req_id) return;
    if (action === 'approve' && (!noticeStart || !noticeEnd)) return;
    if (action === 'reject' && !String(comment || '').trim()) return;
    await api.pmHrRequestAction({
      reqId: active.req_id,
      action,
      comment,
      meetingDate,
      meetingTime,
      noticeStartDate: noticeStart,
      noticeEndDate: noticeEnd,
      noticeDuration: noticeDuration ? Number(noticeDuration) : null
    });
    setActive(null);
    await load();
  };

  const preview = useMemo(() => active?.employee_payload || null, [active]);

  return (
    <div>
      <div className="sec">Offboarding Management</div>
      <div className="cd">
        <div className="cd-h">
          <div className="cd-t">Employee Offboarding Requests</div>
          <div className="cd-s">{rows.length} records</div>
        </div>
        <div className="cd-b pmoffboardingmgmtpg-inline-1">
          {loading ? <div className="pmoffboardingmgmtpg-inline-2">Loading...</div> :
          <table className="tbl">
              <thead>
                <tr>
                  <th>Req ID</th><th>Employee</th><th>Status</th><th>Meeting</th><th>Notice</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ?
              <tr><td colSpan="6" className="pmoffboardingmgmtpg-inline-3">No offboarding requests</td></tr> :
              rows.map((r) =>
              <tr key={r.req_id}>
                    <td className="pmoffboardingmgmtpg-inline-4">{r.req_id}</td>
                    <td>{r.user_name || '-'}</td>
                    <td><span className="chip chip-wn">{r.status}</span></td>
                    <td>{(r.meeting_date || '-') + ' ' + (r.meeting_time || '-')}</td>
                    <td>{r.notice_start_date ? `${r.notice_start_date} to ${r.notice_end_date || '-'}` : '-'}</td>
                    <td><button className="btn-o btn-s" onClick={() => openReq(r)}>Open</button></td>
                  </tr>
              )}
              </tbody>
            </table>
          }
        </div>
      </div>

      <PMModal open={!!active} onClose={() => setActive(null)} title={`Offboarding - ${active?.req_id || ''}`} wide>
        {active &&
        <div>
            <div className="pmoffboardingmgmtpg-inline-5">
              {active.file_url ? <button className="btn-o btn-s" onClick={() => setViewUrl(api.resolveFileUrl(active.file_url))}>Preview Letter</button> : null}
              {active.signature_url ? <button className="btn-o btn-s" onClick={() => setViewUrl(api.resolveFileUrl(active.signature_url))}>Preview Signature</button> : null}
            </div>

            {preview &&
          <div className="pmoffboardingmgmtpg-inline-6">
                <b>Resignation Template</b>
                <div>{preview.employeeName || '-'} ({preview.employeeId || '-'}) | {preview.designation || '-'} | Relieving: {preview.relievingDate || '-'}</div>
                <div>Reason: {preview.reason || '-'}</div>
              </div>
          }

            <div className="fg2 pmoffboardingmgmtpg-inline-7">
              <input className="fi" type="date" value={meetingDate} onChange={(e) => setMeetingDate(e.target.value)} />
              <input className="fi" type="time" value={meetingTime} onChange={(e) => setMeetingTime(e.target.value)} />
            </div>
            <textarea className="fta" rows={2} value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Meeting / review comments" />
            <button className="btn-o btn-s pmoffboardingmgmtpg-inline-8" onClick={() => doAction('schedule')} disabled={!meetingDate || !meetingTime}>Schedule</button>

            <div className="pmoffboardingmgmtpg-inline-9">Notice Period</div>
            <div className="fg3 pmoffboardingmgmtpg-inline-10">
              <input className="fi" type="date" value={noticeStart} onChange={(e) => setNoticeStart(e.target.value)} title="Notice Start Date" />
              <input className="fi" type="date" value={noticeEnd} onChange={(e) => setNoticeEnd(e.target.value)} title="Relieving Date / Notice End Date" />
              <input className="fi" type="number" placeholder="Days (auto)" value={noticeDuration} readOnly />
            </div>
            <div className="pmoffboardingmgmtpg-inline-11">
              Start Date and Relieving Date selected once PM approves. Duration auto calculated.
            </div>

            <div className="pmoffboardingmgmtpg-inline-12">
              <button className="btn btn-ok" onClick={() => doAction('approve')} disabled={!noticeStart || !noticeEnd}>Approve + Send Notice</button>
              <button className="btn btn-dn" onClick={() => doAction('reject')}>Reject</button>
            </div>
          </div>
        }
      </PMModal>

      {viewUrl &&
      <div className="pmoffboardingmgmtpg-inline-13">
          <div className="pmoffboardingmgmtpg-inline-14">
            <div className="pmoffboardingmgmtpg-inline-15">
              <div className="pmoffboardingmgmtpg-inline-16">Preview</div>
              <button className="btn-o btn-s" onClick={() => setViewUrl('')}>Close</button>
            </div>
            <iframe title="pm-offboarding-preview" src={viewUrl} className="pmoffboardingmgmtpg-inline-17" />
          </div>
        </div>
      }
    </div>);

}

export default PMOffboardingMgmtPg;